var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Login__Page" },
    [
      _c("div", { staticClass: "is-flex is-flex-direction-row-reverse" }, [
        _c("div", { staticClass: "Login__Page__Figure" }, [
          _c("div", { staticClass: "img-responsive" }, [
            _vm.portal === "uti"
              ? _c("img", {
                  attrs: { src: require("@/assets/uti_logo_blue.png"), alt: "" }
                })
              : _c("img", {
                  attrs: { src: require("@/assets/login.svg"), alt: "" }
                })
          ])
        ]),
        _c(
          "div",
          {
            staticClass:
              "\n        Login__Page__Form\n        p-6\n        is-flex is-flex-direction-row is-align-items-center\n      "
          },
          [
            _vm.portal === "sosna" &&
            _vm.currentStep === _vm.LOGIN_STEPS.CREDENTIALS
              ? _c("div", { staticClass: "portal-image" }, [
                  _c("img", {
                    attrs: { src: require("../assets/Sosna.jpg"), alt: "" }
                  })
                ])
              : _vm._e(),
            _vm.currentStep === _vm.LOGIN_STEPS.CREDENTIALS
              ? _c(
                  "section",
                  { staticClass: "is-flex is-flex-direction-column" },
                  [
                    _vm.portal === "sosna"
                      ? _c("h1", [_vm._v("ברוכים הבאים לפורטל סוסנה 👋")])
                      : _vm._e(),
                    _vm.portal === "uti"
                      ? _c("h1", [_vm._v("ברוכים הבאים ל-UTI 👋")])
                      : _c("h1", [_vm._v("ברוכים הבאים ל Betterway 👋")]),
                    _c("h3", { staticClass: "subtitle" }, [
                      _vm._v(" להתחברות למערכת יש להקליד את שם המשתמש וסיסמא ")
                    ]),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.login($event)
                          }
                        }
                      },
                      [
                        _c(
                          "b-field",
                          { attrs: { label: "אימייל" } },
                          [
                            _c("b-input", {
                              attrs: {
                                placeholder: "",
                                type: "email",
                                "validation-message":
                                  "כתובת המייל שהוזנה אינה תקנית",
                                "icon-right": "close-circle",
                                "icon-right-clickable": ""
                              },
                              on: { "icon-right-click": _vm.clearIconClick },
                              model: {
                                value: _vm.email,
                                callback: function($$v) {
                                  _vm.email = $$v
                                },
                                expression: "email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "סיסמא" } },
                          [
                            _c("b-input", {
                              attrs: {
                                type: "password",
                                placeholder: "",
                                "password-reveal": ""
                              },
                              model: {
                                value: _vm.password,
                                callback: function($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.loginError
                          ? _c("b-message", { attrs: { type: "is-danger" } }, [
                              _vm._v(" " + _vm._s(_vm.loginError) + " ")
                            ])
                          : _vm._e(),
                        _vm.userLocked
                          ? _c("b-message", { attrs: { type: "is-danger" } }, [
                              _vm._v(
                                " חלו יותר מדי טעויות בזיהוי - המשתמש ננעל לדקה "
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.loading,
                              "native-type": "submit",
                              type: "is-primary"
                            }
                          },
                          [_vm._v("התחברות למערכת")]
                        ),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Forgot",
                                query: { email: _vm.email }
                              }
                            }
                          },
                          [_vm._v("שכחתי סיסמה")]
                        ),
                        _c("span", { staticClass: "or-separator" }, [
                          _vm._v("או")
                        ]),
                        _c(
                          "div",
                          { staticClass: "signin-buttons" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "custom-microsoft-signin-btn",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.loadingMicrosoft,
                                  loading: _vm.loadingMicrosoft
                                },
                                on: { click: _vm.handleMicrosoftLogin }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "ms-btn-icon",
                                    attrs: {
                                      width: "18",
                                      height: "18",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "#F25022",
                                        d: "M1 1h10v10H1z"
                                      }
                                    }),
                                    _c("path", {
                                      attrs: {
                                        fill: "#7FBA00",
                                        d: "M13 1h10v10H13z"
                                      }
                                    }),
                                    _c("path", {
                                      attrs: {
                                        fill: "#00A4EF",
                                        d: "M1 13h10v10H1z"
                                      }
                                    }),
                                    _c("path", {
                                      attrs: {
                                        fill: "#FFB900",
                                        d: "M13 13h10v10H13z"
                                      }
                                    })
                                  ]
                                ),
                                _c("span", { staticClass: "ms-btn-text" }, [
                                  _vm._v("כניסה באמצעות Microsoft")
                                ])
                              ]
                            ),
                            _c("div", {
                              attrs: {
                                id: "google-login-btn",
                                disabled: _vm.loadingGoogle,
                                loading: _vm.loadingGoogle
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm.currentStep === _vm.LOGIN_STEPS.OTP
              ? _c(
                  "section",
                  { staticClass: "is-flex is-flex-direction-column" },
                  [
                    _c("OtpInput", {
                      attrs: {
                        invalidOTP: _vm.invalidOTP,
                        resendCooldown: _vm.resendCooldown
                      },
                      on: {
                        submit: _vm.verifyOTP,
                        resend: _vm.resendOTP,
                        "clear-otp-error": function($event) {
                          _vm.invalidOTP = false
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _c("CookiePopup", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }